var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',_vm._g(_vm._b({attrs:{"value":_vm.value},on:{"input":_vm.onInput,"keydown":_vm.onKeydown,"focus":_vm.onFocus,"click":_vm.onClick}},'b-form-input',_vm.$attrs,false),_vm.forwardedListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }